const paymentOptions = {
  'MONTHLY_INSTALLMENT': 'Monthly Installment',
  'UPFRONT_PAYMENT': 'One time Payment'
}

const programData = {
  details: {
    left: [
      {
        id: 'homeOwnerFirstName',
        label: 'Customer First Name',
        path: 'homeowner_info.first_name'
      },
      {
        id: 'homeOwnerLastName',
        label: 'Customer Last Name',
        path: 'homeowner_info.last_name'
      },
      {
        id: 'address1',
        label: 'Address Line 1',
        path: 'homeowner_info.address1'
      },
      {
        id: 'address2',
        label: 'Address Line 2',
        path: 'homeowner_info.address2'
      },
      {
        id: 'city',
        label: 'City',
        path: 'homeowner_info.city'
      },
      {
        id: 'optionalId',
        label: 'Optional Id',
        path: 'homeowner_info.premise_id'
      }
    ],
    right: [
      {
        id: 'state',
        label: 'State',
        path: 'homeowner_info.state'
      },
      {
        id: 'zip',
        label: 'Zip Code',
        path: 'homeowner_info.zip'
      },
      {
        id: 'ean',
        label: 'Electric Account Number',
        path: 'homeowner_info.electric_account_number'
      },
      {
        id: 'paymentOption',
        label: 'Program Payment Option Type',
        path: 'payment_method'
      },
      {
        id: 'rejectedOn',
        label: 'Application Rejected on',
        rejected: true
      }
    ],
  },
  files: [
    {
      id: 'applicationForm',
      label: 'Application Form',
      path: 'signed_application_form_downloadable_url'
    }
  ]
}

export {
  programData,
  paymentOptions
}